import * as React from "react";
import { AddToCart } from "@grandvisionhq/carts-v2";
import { useIntl } from "@grandvisionhq/state";
import { useGetPriceSegment } from "../../../../../../../../hooks/modules/EcommContent/hooks/use-get-price-segment.js";
const NonRxProductAddToCartButton = ({
  activeSku,
  offeringSku,
  bundleLineItemSkus,
  onSuccess,
  quantity = 1,
  caption,
  ...tealiumProps
}) => {
  const { getLabel } = useIntl();
  const { priceSegment } = useGetPriceSegment();
  let lineItemDraft;
  if (!bundleLineItemSkus || bundleLineItemSkus.length === 0) {
    const draft = {
      sku: activeSku,
      quantity,
      type: "regular"
    };
    if (priceSegment) {
      draft.typeDetails = {
        segments: [{ channelKey: priceSegment }]
      };
    }
    lineItemDraft = draft;
  } else {
    const skus = offeringSku ? [offeringSku, ...bundleLineItemSkus] : bundleLineItemSkus;
    const draft = {
      sku: activeSku,
      quantity: 1,
      type: "non-prescription-bundle",
      bundleLineItems: skus.map((sku) => ({
        sku,
        quantity: 1
      }))
    };
    if (priceSegment) {
      draft.typeDetails = {
        segments: [{ channelKey: priceSegment }]
      };
    }
    lineItemDraft = draft;
  }
  return /* @__PURE__ */ React.createElement(
    AddToCart,
    {
      caption: caption ?? getLabel("products.actions.addToCart"),
      onSuccess,
      lineItemDrafts: [lineItemDraft],
      ...tealiumProps
    }
  );
};
export {
  NonRxProductAddToCartButton
};
//# sourceMappingURL=NonRxProductAddToCartButton.js.map
